// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

export const zItem = z.object({
    e164: z.string().min(1),
    marking_category: z.string().optional()
});

export const zAccountCreateInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    channels: z.coerce.bigint().gte(BigInt(0)).optional(),
    dids: z.union([
        z.array(zItem),
        z.null()
    ]).optional(),
    domain_host: z.string().optional(),
    domain_port: z.coerce.bigint().gte(BigInt(0)).lte(BigInt(65535)).optional(),
    owner_account_id: z.string().optional(),
    owner_type: z.enum([
        'platform',
        'client'
    ]),
    password: z.string().optional(),
    pool_id: z.string().optional(),
    provider_profile_id: z.string().min(1),
    username: z.string().optional()
});

export const zTelephonyDidView = z.object({
    e164: z.string(),
    marking_category: z.string().optional(),
    marking_status: z.string(),
    status: z.string()
});

export const zTelephonyAccountView = z.object({
    channels: z.coerce.bigint(),
    created_at: z.string().datetime(),
    dids: z.union([
        z.array(zTelephonyDidView),
        z.null()
    ]),
    domain_override: z.string().optional(),
    has_secret: z.boolean(),
    id: z.string(),
    owner_account_id: z.string().optional(),
    owner_type: z.string(),
    pool_id: z.string(),
    provider_profile_id: z.string(),
    status: z.string(),
    status_reason: z.string().optional(),
    updated_at: z.string().datetime(),
    username: z.string(),
    version: z.coerce.bigint()
});

export const zAccountListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zTelephonyAccountView),
        z.null()
    ])
});

export const zAccountOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zTelephonyAccountView
});

export const zAccountUpdateInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    channels: z.coerce.bigint().gte(BigInt(1)).optional(),
    domain_host: z.string().optional(),
    domain_port: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(65535)).optional(),
    password: z.string().optional(),
    pool_id: z.string().min(1).optional()
});

export const zPoolCapacityViewCellsStruct = z.object({
    assembling: z.coerce.bigint(),
    draining: z.coerce.bigint(),
    ready: z.coerce.bigint()
});

export const zPoolCapacityView = z.object({
    accounts_active: z.coerce.bigint(),
    cells: zPoolCapacityViewCellsStruct,
    lines_capacity: z.coerce.bigint(),
    lines_leased: z.coerce.bigint(),
    pool: z.string(),
    pool_name: z.string().optional(),
    queue_available: z.boolean(),
    queue_depth: z.coerce.bigint().gte(BigInt(0)).optional(),
    queue_oldest_age_s: z.coerce.bigint().optional(),
    reserved_slots: z.coerce.bigint(),
    sellable_slots: z.coerce.bigint(),
    slots_busy: z.coerce.bigint(),
    slots_free: z.coerce.bigint(),
    slots_total: z.coerce.bigint(),
    state: z.string(),
    usable_lines: z.coerce.bigint(),
    waiting_slots: z.coerce.bigint()
});

export const zCapacityView = z.object({
    '$schema': z.string().url().readonly().optional(),
    cell_slots: z.coerce.bigint(),
    lead_time_s: z.coerce.bigint(),
    pools: z.union([
        z.array(zPoolCapacityView),
        z.null()
    ])
});

export const zErrorDetail = z.object({
    location: z.string().optional(),
    message: z.string().optional(),
    value: z.unknown().optional()
});

export const zErrorModel = z.object({
    '$schema': z.string().url().readonly().optional(),
    code: z.string(),
    detail: z.string().optional(),
    errors: z.union([
        z.array(zErrorDetail),
        z.null()
    ]).optional(),
    instance: z.string().url().optional(),
    status: z.coerce.bigint().optional(),
    title: z.string().optional(),
    type: z.string().url().optional()
});

export const zFleetScalingDecisionView = z.object({
    action: z.string(),
    assembled_cells: z.union([
        z.array(z.string()),
        z.null()
    ]),
    error: z.string().optional(),
    outcome: z.string().optional(),
    pool: z.string().optional(),
    provisioned_units: z.union([
        z.array(z.string()),
        z.null()
    ]),
    reason: z.string().optional(),
    required_slots: z.coerce.bigint(),
    reservation_id: z.string(),
    unfulfilled_slots: z.coerce.bigint(),
    waiting_for: z.union([
        z.array(z.string()),
        z.null()
    ])
});

export const zFleetScalingRunSignalView = z.object({
    count: z.coerce.bigint().optional(),
    kind: z.string(),
    pool: z.string().optional(),
    reason: z.string().optional(),
    reservation_id: z.string().optional(),
    subject_id: z.string().optional(),
    subject_type: z.string().optional(),
    waiting_for: z.union([
        z.array(z.string()),
        z.null()
    ]).optional()
});

export const zFleetAutoscalerView = z.object({
    '$schema': z.string().url().readonly().optional(),
    decisions: z.union([
        z.array(zFleetScalingDecisionView),
        z.null()
    ]),
    finished_at: z.string().datetime().optional(),
    never_ran: z.boolean(),
    signals: z.union([
        z.array(zFleetScalingRunSignalView),
        z.null()
    ]),
    started_at: z.string().datetime().optional(),
    took_ms: z.coerce.bigint()
});

export const zFleetCellAddUnitInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    unit_id: z.string().min(1)
});

export const zFleetCellCreateInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    c_unit_id: z.string().min(1),
    l_unit_ids: z.union([
        z.array(z.string()).min(1),
        z.null()
    ]),
    pool: z.string().min(1),
    reservation_id: z.string().optional()
});

export const zFleetCellView = z.object({
    c_unit_id: z.string(),
    created_at: z.string().datetime(),
    id: z.string(),
    l_unit_ids: z.union([
        z.array(z.string()),
        z.null()
    ]),
    lines_leased: z.coerce.bigint(),
    pool: z.string(),
    reservation_id: z.string().optional(),
    slots_busy: z.coerce.bigint(),
    slots_honest: z.coerce.bigint(),
    slots_total: z.coerce.bigint(),
    status: z.string(),
    updated_at: z.string().datetime(),
    version: z.coerce.bigint()
});

export const zFleetCellOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zFleetCellView
});

export const zFleetCellPlanView = z.object({
    cell_id: z.string(),
    note: z.string().optional(),
    state: z.string()
});

export const zFleetDemoCallInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    allow_client_units: z.boolean().optional(),
    cell_id: z.string().optional(),
    line: z.enum([
        'webrtc',
        'sip'
    ]).optional(),
    phone: z.string().optional(),
    prompt: z.string().optional(),
    record: z.boolean().optional(),
    scenario_id: z.string().optional(),
    sdp_offer: z.string().optional(),
    voice_id: z.string().optional()
});

export const zFleetDemoCallOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    call_id: z.string(),
    sdp_answer: z.string()
});

export const zFleetEtalonInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    class: z.enum([
        'C',
        'L',
        'c',
        'l'
    ]),
    provider_server_id: z.string().min(1)
});

export const zFleetProviderView = z.object({
    etalons: z.object({}),
    id: z.string(),
    name: z.string(),
    pause_semantics: z.string(),
    status: z.string(),
    supported_classes: z.union([
        z.array(z.string()),
        z.null()
    ])
});

export const zFleetUnitLlmUsageView = z.object({
    active: z.coerce.bigint(),
    target: z.string()
});

export const zFleetUnitView = z.object({
    capacity_slots: z.coerce.bigint(),
    cell_id: z.string().optional(),
    class: z.string(),
    cost_cents: z.coerce.bigint().optional(),
    created_at: z.string().datetime(),
    currency: z.string(),
    gpu_model: z.string(),
    hb_slots_total: z.coerce.bigint(),
    heartbeat_at: z.string().datetime().optional(),
    heartbeat_stale: z.boolean(),
    hourly_price_cents: z.coerce.bigint(),
    id: z.string(),
    image_version: z.string().optional(),
    llm_usage: z.union([
        z.array(zFleetUnitLlmUsageView),
        z.null()
    ]).optional(),
    pause_seconds: z.coerce.bigint().optional(),
    pending_reports: z.coerce.bigint(),
    provider_account_id: z.string(),
    provider_server_id: z.string().optional(),
    public_ip: z.string().optional(),
    reservation_id: z.string().optional(),
    run_seconds: z.coerce.bigint().optional(),
    slots_busy: z.coerce.bigint(),
    status: z.string(),
    updated_at: z.string().datetime(),
    version: z.coerce.bigint(),
    wg_address: z.string().optional(),
    wg_public_key: z.string().optional()
});

export const zFleetOverviewView = z.object({
    '$schema': z.string().url().readonly().optional(),
    cells: z.union([
        z.array(zFleetCellView),
        z.null()
    ]),
    providers: z.union([
        z.array(zFleetProviderView),
        z.null()
    ]),
    units: z.union([
        z.array(zFleetUnitView),
        z.null()
    ])
});

export const zFleetPauseSemanticsInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    pause_semantics: z.enum([
        'frees-gpu',
        'billed'
    ])
});

export const zFleetProviderCreateInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    api_key: z.string().min(1),
    id: z.string().min(1),
    name: z.string().min(1),
    supported_classes: z.union([
        z.array(z.string()).min(1),
        z.null()
    ])
});

export const zFleetProviderListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zFleetProviderView),
        z.null()
    ])
});

export const zFleetProviderOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zFleetProviderView
});

export const zFleetProvisionOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zFleetUnitView,
    engine_token: z.string(),
    unit_token: z.string()
});

export const zFleetScaleDownInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    cell_ids: z.union([
        z.array(z.string()).min(1),
        z.null()
    ]),
    mode: z.enum([
        'auto',
        'delete'
    ]).optional()
});

export const zFleetScaleDownOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    cells: z.union([
        z.array(zFleetCellPlanView),
        z.null()
    ])
});

export const zFleetScaleUpInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    required_slots: z.coerce.bigint().gte(BigInt(1)),
    reservation_id: z.string().min(1)
});

export const zFleetScaleUpOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    assembled_cells: z.union([
        z.array(z.string()),
        z.null()
    ]),
    provisioned_units: z.union([
        z.array(z.string()),
        z.null()
    ]),
    reason: z.string().optional(),
    unfulfilled_slots: z.coerce.bigint(),
    waiting_for: z.union([
        z.array(z.string()),
        z.null()
    ]),
    waiting_lines: z.boolean()
});

export const zFleetScannedServerView = z.object({
    currency: z.string(),
    etalon_for: z.union([
        z.array(z.string()),
        z.null()
    ]).optional(),
    gpu_model: z.string().optional(),
    hourly_price_cents: z.coerce.bigint(),
    name: z.string(),
    provider_server_id: z.string(),
    public_ip: z.string().optional(),
    status: z.string(),
    unit_id: z.string().optional()
});

export const zFleetScanOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zFleetScannedServerView),
        z.null()
    ])
});

export const zFleetSignalDetails = z.object({
    count: z.coerce.bigint().optional(),
    note: z.string().optional(),
    pool: z.string().optional(),
    reason: z.string().optional(),
    reservation_id: z.string().optional(),
    waiting_for: z.union([
        z.array(z.string()),
        z.null()
    ]).optional()
});

export const zFleetSignalView = z.object({
    active: z.boolean(),
    cleared_at: z.string().datetime().optional(),
    derived: z.boolean(),
    details: zFleetSignalDetails,
    first_seen_at: z.string().datetime(),
    id: z.string(),
    kind: z.string(),
    last_seen_at: z.string().datetime(),
    subject_id: z.string(),
    subject_type: z.string()
});

export const zFleetSignalListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zFleetSignalView),
        z.null()
    ])
});

export const zFleetSignalOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zFleetSignalView
});

export const zFleetTestCallInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    phone: z.string().min(8).regex(/^\+[1-9][0-9]{6,14}$/),
    pool: z.string().min(1),
    record: z.boolean().optional(),
    reservation: z.string().optional(),
    scenario_id: z.string().min(1),
    voice_id: z.string().optional()
});

export const zFleetTestCallOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    call_id: z.string()
});

export const zFleetUnitCreateInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    class: z.enum([
        'C',
        'L',
        'c',
        'l'
    ]),
    gpu_model: z.string().optional(),
    provider_account_id: z.string().min(1)
});

export const zFleetUnitListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zFleetUnitView),
        z.null()
    ])
});

export const zFleetUnitOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zFleetUnitView
});

export const zFleetWgPeerView = z.object({
    allowed_ips: z.string(),
    public_key: z.string()
});

export const zFleetWgPeersOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zFleetWgPeerView),
        z.null()
    ])
});

export const zHealthBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    status: z.string()
});

export const zTelephonyLeaseView = z.object({
    created_at: z.string().datetime(),
    id: z.string(),
    lines_count: z.coerce.bigint(),
    pool_id: z.string(),
    sip_account_id: z.string(),
    status: z.string(),
    unit_id: z.string(),
    updated_at: z.string().datetime(),
    version: z.coerce.bigint()
});

export const zLeaseListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zTelephonyLeaseView),
        z.null()
    ])
});

export const zLeaseOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zTelephonyLeaseView
});

export const zMeteringCallOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    account_id: z.string(),
    answered_at: z.string().datetime().optional(),
    backchannels: z.coerce.bigint(),
    barges: z.coerce.bigint(),
    billable_ms: z.coerce.bigint(),
    cached_share: z.number(),
    cached_tokens: z.coerce.bigint(),
    call_id: z.string(),
    completion_tokens: z.coerce.bigint(),
    decide_errs: z.coerce.bigint(),
    duration_ms: z.coerce.bigint(),
    empty_commits: z.coerce.bigint(),
    ended_at: z.string().datetime(),
    ended_reason: z.string().optional(),
    false_barges: z.coerce.bigint(),
    fao_p50_ms: z.coerce.bigint(),
    greeting_fao_ms: z.coerce.bigint(),
    has_recording: z.boolean(),
    intent_hint: z.string().optional(),
    interrupted: z.coerce.bigint(),
    language: z.string().optional(),
    line: z.string(),
    llm_length_finish: z.coerce.bigint(),
    llm_target: z.string().optional(),
    normal_turns: z.coerce.bigint(),
    outcome: z.string(),
    pacer_underruns: z.coerce.bigint(),
    perceived_max_ms: z.coerce.bigint(),
    perceived_p50_ms: z.coerce.bigint(),
    persist_ok: z.union([
        z.boolean(),
        z.null()
    ]),
    pool: z.string().optional(),
    premature_eou: z.coerce.bigint(),
    prompt_tokens: z.coerce.bigint(),
    recording_key: z.string().optional(),
    report: z.unknown().optional(),
    reservation: z.string().optional(),
    settle_hard: z.coerce.bigint(),
    sip_code: z.coerce.bigint().optional(),
    spec_promoted: z.coerce.bigint(),
    spec_started: z.coerce.bigint(),
    started_at: z.string().datetime(),
    tts_errors: z.coerce.bigint(),
    turns: z.coerce.bigint(),
    unheard_frames: z.coerce.bigint()
});

export const zMeteringCallSummary = z.object({
    account_id: z.string(),
    answered_at: z.string().datetime().optional(),
    backchannels: z.coerce.bigint(),
    barges: z.coerce.bigint(),
    billable_ms: z.coerce.bigint(),
    cached_share: z.number(),
    cached_tokens: z.coerce.bigint(),
    call_id: z.string(),
    completion_tokens: z.coerce.bigint(),
    decide_errs: z.coerce.bigint(),
    duration_ms: z.coerce.bigint(),
    empty_commits: z.coerce.bigint(),
    ended_at: z.string().datetime(),
    ended_reason: z.string().optional(),
    false_barges: z.coerce.bigint(),
    fao_p50_ms: z.coerce.bigint(),
    greeting_fao_ms: z.coerce.bigint(),
    intent_hint: z.string().optional(),
    interrupted: z.coerce.bigint(),
    language: z.string().optional(),
    line: z.string(),
    llm_length_finish: z.coerce.bigint(),
    llm_target: z.string().optional(),
    normal_turns: z.coerce.bigint(),
    outcome: z.string(),
    pacer_underruns: z.coerce.bigint(),
    perceived_max_ms: z.coerce.bigint(),
    perceived_p50_ms: z.coerce.bigint(),
    persist_ok: z.union([
        z.boolean(),
        z.null()
    ]),
    pool: z.string().optional(),
    premature_eou: z.coerce.bigint(),
    prompt_tokens: z.coerce.bigint(),
    recording_key: z.string().optional(),
    reservation: z.string().optional(),
    settle_hard: z.coerce.bigint(),
    sip_code: z.coerce.bigint().optional(),
    spec_promoted: z.coerce.bigint(),
    spec_started: z.coerce.bigint(),
    started_at: z.string().datetime(),
    tts_errors: z.coerce.bigint(),
    turns: z.coerce.bigint(),
    unheard_frames: z.coerce.bigint()
});

export const zMeteringCallTelemetryOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    barges: z.union([
        z.array(z.unknown()),
        z.null()
    ]),
    call: z.unknown(),
    call_id: z.string(),
    ctrl_events: z.union([
        z.array(z.unknown()),
        z.null()
    ]),
    detects: z.union([
        z.array(z.unknown()),
        z.null()
    ]),
    empty_commits: z.union([
        z.array(z.unknown()),
        z.null()
    ]),
    nudges: z.union([
        z.array(z.unknown()),
        z.null()
    ]),
    pacer_gaps: z.union([
        z.array(z.unknown()),
        z.null()
    ]),
    segments: z.union([
        z.array(z.unknown()),
        z.null()
    ]),
    turns: z.union([
        z.array(z.unknown()),
        z.null()
    ]),
    utterances: z.union([
        z.array(z.unknown()),
        z.null()
    ])
});

export const zMeteringLiveCall = z.object({
    account_id: z.string(),
    at: z.string().datetime(),
    call_id: z.string(),
    kind: z.string(),
    reservation_id: z.string().optional()
});

export const zMeteringCallsOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    completed: z.union([
        z.array(zMeteringCallSummary),
        z.null()
    ]),
    live: z.union([
        z.array(zMeteringLiveCall),
        z.null()
    ])
});

export const zMeteringHangupOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    status: z.string()
});

export const zMeteringUsageRow = z.object({
    account_id: z.string(),
    billable_seconds: z.coerce.bigint(),
    by_outcome: z.object({}),
    calls: z.coerce.bigint(),
    duration_seconds: z.coerce.bigint()
});

export const zMeteringUsageOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zMeteringUsageRow),
        z.null()
    ])
});

export const zPoolCreateInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    id: z.string().min(1),
    market: z.enum([
        'ru',
        'sa',
        'eu'
    ]),
    name: z.string().min(1),
    owner_account_id: z.string().optional(),
    owner_type: z.enum([
        'platform',
        'client'
    ])
});

export const zTelephonyPoolView = z.object({
    created_at: z.string().datetime(),
    id: z.string(),
    market: z.string(),
    name: z.string(),
    owner_account_id: z.string().optional(),
    owner_type: z.string(),
    status: z.string(),
    updated_at: z.string().datetime(),
    version: z.coerce.bigint()
});

export const zPoolListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zTelephonyPoolView),
        z.null()
    ])
});

export const zPoolOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zTelephonyPoolView
});

export const zProfileCreateInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    api_provisioning: z.boolean().optional(),
    auth_mode: z.enum([
        'register',
        'invite'
    ]),
    channels_per_account: z.coerce.bigint().gte(BigInt(0)).optional(),
    codecs: z.union([
        z.array(z.string()).min(1),
        z.null()
    ]),
    dtmf_mode: z.string().optional(),
    id: z.string().min(1),
    market: z.enum([
        'ru',
        'sa',
        'eu'
    ]),
    media_security: z.enum([
        'rtp',
        'srtp'
    ]),
    name: z.string().min(1),
    nat_keepalive_sec: z.coerce.bigint().gte(BigInt(0)).optional(),
    quirks: z.object({}).optional(),
    reg_expires_sec: z.coerce.bigint().gte(BigInt(0)).optional(),
    registrar_host: z.string().min(1),
    registrar_port: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(65535)),
    supports_marking: z.boolean().optional(),
    transport: z.enum([
        'udp',
        'tcp',
        'tls'
    ])
});

export const zTelephonyProfileView = z.object({
    api_provisioning: z.boolean(),
    auth_mode: z.string(),
    channels_cap: z.coerce.bigint(),
    channels_per_account: z.coerce.bigint(),
    codecs: z.union([
        z.array(z.string()),
        z.null()
    ]),
    created_at: z.string().datetime(),
    dtmf_mode: z.string().optional(),
    id: z.string(),
    market: z.string(),
    media_security: z.string(),
    name: z.string(),
    nat_keepalive_sec: z.coerce.bigint().optional(),
    quirks: z.object({}).optional(),
    reg_expires_sec: z.coerce.bigint().optional(),
    registrar: z.string(),
    retired: z.boolean(),
    supports_marking: z.boolean(),
    transport: z.string(),
    updated_at: z.string().datetime(),
    version: z.coerce.bigint()
});

export const zProfileListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zTelephonyProfileView),
        z.null()
    ])
});

export const zProfileOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zTelephonyProfileView
});

export const zReservationCostView = z.object({
    cents: z.coerce.bigint().optional(),
    currency: z.string().optional(),
    source: z.string(),
    units: z.coerce.bigint()
});

export const zReservationCreateInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    account_id: z.string().optional(),
    from_at: z.string().datetime().optional(),
    id: z.string().min(1).max(64).regex(/^[A-Za-z0-9_-]+$/),
    planned_until: z.string().datetime(),
    pool: z.string().min(1),
    slots: z.coerce.bigint().gte(BigInt(4))
});

export const zReservationDrainView = z.object({
    active_calls: z.coerce.bigint(),
    cells_draining: z.coerce.bigint(),
    cells_remaining: z.coerce.bigint(),
    cells_total: z.coerce.bigint(),
    pending_reports: z.coerce.bigint(),
    reports_deadline_at: z.string().datetime().optional(),
    reports_deadline_in_s: z.coerce.bigint().optional(),
    reports_grace_s: z.coerce.bigint(),
    units_pending: z.coerce.bigint()
});

export const zReservationExtendInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    planned_until: z.string().datetime()
});

export const zReservationWindowView = z.object({
    from_at: z.string().datetime(),
    id: z.string(),
    planned_until: z.string().datetime(),
    slots: z.coerce.bigint(),
    status: z.string()
});

export const zReservationView = z.object({
    account_id: z.string().optional(),
    cells: z.union([
        z.array(z.string()),
        z.null()
    ]),
    cost: zReservationCostView.optional(),
    created_at: z.string().datetime(),
    drain: zReservationDrainView.optional(),
    from_at: z.string().datetime(),
    id: z.string(),
    overdue: z.boolean(),
    planned_until: z.string().datetime(),
    pool: z.string(),
    pool_name: z.string().optional(),
    queue_subject: z.string(),
    ready_at: z.string().datetime().optional(),
    slots: z.coerce.bigint(),
    slots_busy: z.coerce.bigint(),
    slots_ready: z.coerce.bigint(),
    status: z.string(),
    updated_at: z.string().datetime(),
    version: z.coerce.bigint(),
    waiting_for: z.union([
        z.array(z.string()),
        z.null()
    ]),
    waiting_for_windows: z.union([
        z.array(zReservationWindowView),
        z.null()
    ]).optional()
});

export const zReservationListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zReservationView),
        z.null()
    ])
});

export const zReservationOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zReservationView
});

export const zScenarioCollectFieldDto = z.object({
    hint: z.string().optional(),
    name: z.string().min(1)
});

export const zScenarioCreateBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    collect_fields: z.union([
        z.array(zScenarioCollectFieldDto),
        z.null()
    ]).optional(),
    control_body: z.string().optional(),
    default_voice_id: z.string().optional(),
    end_reasons: z.union([
        z.array(z.string()),
        z.null()
    ]).optional(),
    extra_prompt: z.string().optional(),
    language: z.enum([
        'ru',
        'en',
        'ar',
        ''
    ]).optional(),
    name: z.string().min(1).max(120),
    owner_account_id: z.string().regex(/^([A-Za-z0-9_-]{1,64})?$/).optional(),
    persona: z.string().optional(),
    script: z.string().optional(),
    style: z.string().optional()
});

export const zScenarioView = z.object({
    collect_fields: z.union([
        z.array(zScenarioCollectFieldDto),
        z.null()
    ]),
    control_body: z.string(),
    created_at: z.string().datetime(),
    default_voice_id: z.string(),
    end_reasons: z.union([
        z.array(z.string()),
        z.null()
    ]),
    extra_prompt: z.string(),
    id: z.string(),
    language: z.string(),
    name: z.string(),
    owner_account_id: z.string(),
    persona: z.string(),
    prompt_preview: z.string(),
    revision: z.coerce.bigint(),
    script: z.string(),
    style: z.string(),
    updated_at: z.string().datetime()
});

export const zScenarioListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zScenarioView),
        z.null()
    ])
});

export const zScenarioOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zScenarioView
});

export const zScenarioUpdateBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    collect_fields: z.union([
        z.array(zScenarioCollectFieldDto),
        z.null()
    ]).optional(),
    control_body: z.string().optional(),
    default_voice_id: z.string().optional(),
    end_reasons: z.union([
        z.array(z.string()),
        z.null()
    ]).optional(),
    extra_prompt: z.string().optional(),
    language: z.enum([
        'ru',
        'en',
        'ar',
        ''
    ]).optional(),
    name: z.string().min(1).max(120),
    persona: z.string().optional(),
    revision: z.coerce.bigint().gte(BigInt(1)).optional(),
    script: z.string().optional(),
    style: z.string().optional()
});

export const zTelephonyProfileBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    api_provisioning: z.boolean().optional(),
    auth_mode: z.enum([
        'register',
        'invite'
    ]),
    channels_per_account: z.coerce.bigint().gte(BigInt(0)).optional(),
    codecs: z.union([
        z.array(z.string()).min(1),
        z.null()
    ]),
    dtmf_mode: z.string().optional(),
    market: z.enum([
        'ru',
        'sa',
        'eu'
    ]),
    media_security: z.enum([
        'rtp',
        'srtp'
    ]),
    name: z.string().min(1),
    nat_keepalive_sec: z.coerce.bigint().gte(BigInt(0)).optional(),
    quirks: z.object({}).optional(),
    reg_expires_sec: z.coerce.bigint().gte(BigInt(0)).optional(),
    registrar_host: z.string().min(1),
    registrar_port: z.coerce.bigint().gte(BigInt(1)).lte(BigInt(65535)),
    supports_marking: z.boolean().optional(),
    transport: z.enum([
        'udp',
        'tcp',
        'tls'
    ])
});

export const zUnitClaimInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    bootstrap_token: z.string().min(1),
    wg_public_key: z.string().optional()
});

export const zUnitWgBody = z.object({
    address: z.string(),
    allowed_ips: z.string(),
    hub_endpoint: z.string(),
    hub_public_key: z.string(),
    keepalive: z.coerce.bigint()
});

export const zUnitClaimOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    class: z.string(),
    unit_id: z.string(),
    unit_token: z.string(),
    wg: zUnitWgBody.optional()
});

export const zUnitConfigSip = z.object({
    password: z.string(),
    realm: z.string(),
    registrar: z.string(),
    user: z.string()
});

export const zUnitConfigLine = z.object({
    line_id: z.string(),
    sip: zUnitConfigSip
});

export const zUnitConfigBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    allow_prefixes: z.union([
        z.array(z.string()),
        z.null()
    ]),
    cell_id: z.string(),
    class: z.string(),
    desired_state: z.string(),
    engine_token: z.string().optional(),
    image_version: z.string(),
    lines: z.union([
        z.array(zUnitConfigLine),
        z.null()
    ]),
    llm_slots: z.union([
        z.array(z.coerce.bigint()),
        z.null()
    ]).optional(),
    llm_targets: z.union([
        z.array(z.string()),
        z.null()
    ]),
    pool: z.string(),
    reservation: z.string(),
    slots_total: z.coerce.bigint(),
    unit_id: z.string(),
    wg: zUnitWgBody.optional()
});

export const zUnitHeartbeatLine = z.object({
    line_id: z.string(),
    registered: z.boolean()
});

export const zUnitHeartbeatLlm = z.object({
    active: z.coerce.bigint().gte(BigInt(0)),
    target: z.string()
});

export const zUnitHeartbeatInputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    active_calls: z.coerce.bigint().gte(BigInt(0)),
    at: z.string().datetime().optional(),
    image_version: z.string().optional(),
    lines: z.union([
        z.array(zUnitHeartbeatLine),
        z.null()
    ]).optional(),
    llm_usage: z.union([
        z.array(zUnitHeartbeatLlm),
        z.null()
    ]).optional(),
    pending_reports: z.coerce.bigint().gte(BigInt(0)).optional(),
    slots_busy: z.coerce.bigint().gte(BigInt(0)),
    slots_total: z.coerce.bigint().gte(BigInt(0)),
    state: z.enum([
        'bootstrapping',
        'ready',
        'draining'
    ])
});

export const zVoiceView = z.object({
    created_at: z.string().datetime(),
    id: z.string(),
    name: z.string(),
    owner_account_id: z.string(),
    ref_clip_key: z.string(),
    ref_text: z.string(),
    status: z.string()
});

export const zVoiceListOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: z.union([
        z.array(zVoiceView),
        z.null()
    ])
});

export const zVoiceOutputBody = z.object({
    '$schema': z.string().url().readonly().optional(),
    data: zVoiceView
});

export const zGetCallsResponse = zMeteringCallsOutputBody;

export const zGetCallResponse = zMeteringCallOutputBody;

export const zHangupCallResponse = zMeteringHangupOutputBody;

export const zGetCallTelemetryResponse = zMeteringCallTelemetryOutputBody;

export const zGetCapacityResponse = zCapacityView;

export const zListReservationsResponse = zReservationListOutputBody;

export const zReserveCapacityResponse = zReservationOutputBody;

export const zGetReservationResponse = zReservationOutputBody;

export const zExtendReservationResponse = zReservationOutputBody;

export const zReleaseReservationResponse = zReservationOutputBody;

export const zStartDemoCallResponse = zFleetDemoCallOutputBody;

export const zFleetAutoscalerResponse = zFleetAutoscalerView;

export const zAssembleCellResponse = zFleetCellOutputBody;

export const zDeleteCellResponse = z.void();

export const zGetFleetCellResponse = zFleetCellOutputBody;

export const zAddUnitToCellResponse = zFleetCellOutputBody;

export const zFleetOverviewResponse = zFleetOverviewView;

export const zListFleetProvidersResponse = zFleetProviderListOutputBody;

export const zCreateFleetProviderResponse = zFleetProviderOutputBody;

export const zSetProviderEtalonResponse = zFleetProviderOutputBody;

export const zConfirmPauseSemanticsResponse = zFleetProviderOutputBody;

export const zScanFleetProviderResponse = zFleetScanOutputBody;

export const zScaleDownResponse = zFleetScaleDownOutputBody;

export const zScaleUpResponse = zFleetScaleUpOutputBody;

export const zListFleetSignalsResponse = zFleetSignalListOutputBody;

export const zClearFleetSignalResponse = zFleetSignalOutputBody;

export const zListFleetUnitsResponse = zFleetUnitListOutputBody;

export const zProvisionUnitResponse = zFleetProvisionOutputBody;

export const zGetFleetUnitResponse = zFleetUnitOutputBody;

export const zDeleteUnitResponse = zFleetUnitOutputBody;

export const zPauseUnitResponse = zFleetUnitOutputBody;

export const zResumeUnitResponse = zFleetUnitOutputBody;

export const zFleetWgPeersResponse = zFleetWgPeersOutputBody;

export const zListScenariosResponse = zScenarioListOutputBody;

export const zCreateScenarioResponse = zScenarioOutputBody;

export const zDeleteScenarioResponse = z.void();

export const zGetScenarioResponse = zScenarioOutputBody;

export const zUpdateScenarioResponse = zScenarioOutputBody;

export const zListSipAccountsResponse = zAccountListOutputBody;

export const zRegisterSipAccountResponse = zAccountOutputBody;

export const zDeleteSipAccountResponse = z.void();

export const zGetSipAccountResponse = zAccountOutputBody;

export const zUpdateSipAccountResponse = zAccountOutputBody;

export const zDisableSipAccountResponse = zAccountOutputBody;

export const zVerifySipAccountResponse = zAccountOutputBody;

export const zListLineLeasesResponse = zLeaseListOutputBody;

export const zReleaseLineLeaseResponse = zLeaseOutputBody;

export const zListTelephonyPoolsResponse = zPoolListOutputBody;

export const zCreateTelephonyPoolResponse = zPoolOutputBody;

export const zGetTelephonyPoolResponse = zPoolOutputBody;

export const zDisableTelephonyPoolResponse = zPoolOutputBody;

export const zEnableTelephonyPoolResponse = zPoolOutputBody;

export const zListTelephonyProfilesResponse = zProfileListOutputBody;

export const zCreateTelephonyProfileResponse = zProfileOutputBody;

export const zRetireTelephonyProfileResponse = zProfileOutputBody;

export const zGetTelephonyProfileResponse = zProfileOutputBody;

export const zUpdateTelephonyProfileResponse = zProfileOutputBody;

export const zStartTestCallResponse = zFleetTestCallOutputBody;

export const zUnitClaimResponse = zUnitClaimOutputBody;

export const zUnitConfigResponse = zUnitConfigBody;

export const zUnitHeartbeatResponse = z.void();

export const zGetUsageResponse = zMeteringUsageOutputBody;

export const zListVoicesResponse = zVoiceListOutputBody;

export const zCreateVoiceResponse = zVoiceOutputBody;

export const zDeleteVoiceResponse = z.void();

export const zGetVoiceResponse = zVoiceOutputBody;

export const zGetHealthResponse = zHealthBody;

export const zGetReadyResponse = zHealthBody;